import React from 'react'
import {
  EditOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined
} from '@ant-design/icons'
import { Button } from 'antd'
import {
  ReceivedQuestionHeader,
  ReceivedQuestionTitle,
  ReceivedQuestionBody,
  QuestionTitlea,
  QuestionIcon
} from './style'

const ReceivedChoice = (props) => {
  const { points, question_text, choices, auto_graded, question_number, ans } =
    props.question

  return (
    <ReceivedQuestionHeader>
      <ReceivedQuestionTitle>
        <QuestionIcon>
          (Points : {points})
          <Button
            icon={<EditOutlined />}
            style={{ border: '0px', marginRight: '5px' }}
            onClick={() => props.draftQuestion(question_number)}
          ></Button>
        </QuestionIcon>
        <QuestionTitlea>
          <b>Question {question_number}:</b> {question_text}
        </QuestionTitlea>
      </ReceivedQuestionTitle>
      <ReceivedQuestionBody>
        <p>
          <b>Choices:</b>
        </p>
        {choices ? (
          choices?.map((value, index) => (
            <p key={index}>
              &nbsp;{index + 1}{'. '}{value}
              {value === ans && (
                <CheckCircleOutlined
                  style={{ fontSize: '16px', color: '#108ee9', margin: '5px' }}
                />
              )}{' '}
            </p>
          ))
        ) : (
          <p>invalid choices</p>
        )}
        <hr style={{ border: '0.5px solid #c2c2c2' }} />
        <div>
          <b>Question Type :</b> Choice   &nbsp; AutoGraded :{' '}
          {auto_graded ? (
            <CheckCircleOutlined
              style={{ fontSize: '16px', color: '#108ee9', margin: '5px' }}
            />
          ) : (
            <CloseCircleOutlined
              style={{ fontSize: '16px', color: 'gray', margin: '5px' }}
            />
          )}
        </div>
      </ReceivedQuestionBody>
    </ReceivedQuestionHeader>
  )
}

export default ReceivedChoice
